import type { Channel } from "./domain";

const paths: Readonly<Record<Channel, string>> = {
  email: "M3 5h18v14H3z M3 5l9 8 9-8",
  text: "M4 4h16v12H9l-5 4V4z M8 8h8 M8 12h5",
  app_notification: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9 M10 21h4",
};

export function channelIcon(channel: Channel): SVGSVGElement {
  const namespace = "http://www.w3.org/2000/svg";
  const icon = document.createElementNS(namespace, "svg");
  icon.setAttribute("class", "channel-icon");
  icon.setAttribute("viewBox", "0 0 24 24");
  icon.setAttribute("fill", "none");
  icon.setAttribute("stroke", "currentColor");
  icon.setAttribute("stroke-width", "2");
  icon.setAttribute("stroke-linecap", "round");
  icon.setAttribute("stroke-linejoin", "round");
  icon.setAttribute("aria-hidden", "true");
  icon.setAttribute("focusable", "false");
  const path = document.createElementNS(namespace, "path");
  path.setAttribute("d", paths[channel]);
  icon.append(path);
  return icon;
}
